// extracted by mini-css-extract-plugin
module.exports = {"fullWidth":"Feedback-module__fullWidth___11ltF"};